import React from "react";

import ErrorBoundaryFallback from "./ErrorBoundaryFallback";

export type ErrorBoundaryProps = React.PropsWithChildren<{
  fallback?: React.ReactNode;
}>;

type ErrorBoundaryState = {
  error: Error | null;
  errorInfo: React.ErrorInfo | null;
};

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  public state: ErrorBoundaryState;

  public constructor(props: ErrorBoundaryProps) {
    super(props);

    this.state = { error: null, errorInfo: null };
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Here you can log the error wherever you want.
    if (process.env.NODE_ENV !== "production") {
      console.error(
        "There is an error catched by an error boundary :",
        { error },
        { errorInfo }
      );
    }

    this.setState({ error, errorInfo });
  }

  public render() {
    if (this.state.error !== null) {
      return this.props.fallback || <ErrorBoundaryFallback />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
